module.exports = __webpack_public_path__ + "350b01b45f3ab076810d99244afb9279.svg";